import request from '../request';

/** 通知提醒 */
export async function getNotificationBadge() {
  return request<API.CommonResponse<API.NotificationBadgeVO>>({
    url: '/api/mall/rest/member/notification/badge',
    method: 'POST',
  });
}

/** 通知中心 */
export async function getNotificationList(params: API.NotificationListPageReq) {
  return request<API.CommonPageInfoResponse<API.NotificationVO[]>>({
    url: '/api/mall/rest/member/notification/list/page',
    method: 'POST',
    data: params,
  });
}
